import { Component } from '@angular/core';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.html'
})
export class NotFoundComponent {
  public currentCount = 0;

  public incrementNotFound() {
    this.currentCount++;
  }
}
